import React from "react";
import { Typography, Button, Box } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { Add, Create } from "@mui/icons-material";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import { getImages } from "../const";

const NoRecentChatScreen = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const handleGoToInbox = () => {
    navigate("/inbox");
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="calc(100% - 164px)"
      textAlign="center"
      padding={3}
    >
      <img
        src={getImages("no_messages.png")} // Replace with your image path
        // alt="No Data"
        style={{
          width:'150px',
          height:'130px',
          // marginBottom: "20px",
          background: "gray",
          borderRadius: 8,
          mixBlendMode: "multiply",
        }} // Adjust the size as needed
      />
      <Typography
      variant="h6"
        sx={{
          fontSize:'1rem',
          color: "secondary.main",
          fontWeight: 600,
        }}
        gutterBottom
      >
        No recent chat history available.
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize:'0.9rem',
          color: "lightSecondary.main",
          fontWeight: 500,
        }}
        gutterBottom
      >
        Take the first step—your next great conversation is just a click away !
      </Typography>

      <Button
        onClick={handleGoToInbox}
        variant="contained"
        sx={{
          textTransform: "inherit",
          mt: 1,
          py: "9px",
          boxShadow: "none",
          px: 5.5,
          "&:hover": {
            boxShadow: "none",
          },
          [theme.breakpoints.down("md")]: {
            px: 2.5,
            width: "100%",
          },
        }}
      >
        {/* <AddIcon
              sx={{
                fontSize: "20px",
                marginRight: "8px",
              }}
            /> */}
        Go To Inbox
      </Button>
    </Box>
  );
};

export default NoRecentChatScreen;
